import React, { useState, useEffect, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { getShipping, deleteShipper, addShipper, updateShipper } from "../../redux/actions/shipping";
import { loadCountry } from "../../redux/actions/adminCountry";
import { loadState } from "../../redux/actions/adminState";
import { loadCity } from "../../redux/actions/adminCity";
import { getRights } from "../../redux/actions/userRights.action";

import { PlusOutlined, EditOutlined, DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Space, Checkbox, Row, Col, Popconfirm } from "antd";

import Tables from "../../components/Table/Tables";

import { ReadCookie } from "../../utils/readCookie"
import notification from "../../utils/notification";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { addVendorShipper, deleteVendorShipper, getVendorShipping, updateVendorShipper } from "../../redux/actions/vendor_ship.action";

const { confirm } = Modal;
const { Option } = Select;

export default function VendorShipping({ vendor_id, token, formType, addressDataShip, deletedShipItems, setDeletedShipItems }) {

  const { Shipping, City, State, userRights, country } = useSelector((state) => state);
  const [customer_idForm, setcustomer_idForm] = useState(null);
  const [shippingAddress, setShippingAddress] = useState([]);
  const [disableFields, setDisableFields] = useState(false);
  const [shippingObj, setShippingObj] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [countryForm, setCountry] = useState(null);
  const [visible, setVisible] = useState(false);
  const [stateForm, setState] = useState(null);
  const [editForm, setEditForm] = useState("");
  const [shipID, setShipID] = useState(null);
  const [eventType, setEventType] = useState("");

  const [cityForm, setCity] = useState(null);
  const [count, setCount] = useState(null);
  const menuId = ReadCookie('menuId');
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [check, setCheck] = useState(true);


  useLayoutEffect(() => {
    dispatch(getRights(token, menuId)).then((res) => {
      if (res.type === "GET_USER_RIGHTS_SUCCESS") {
        if (!res?.payload.can_add) {

        }
      }
    });
  }, [])

  const shippingColumns = [
    {
      title: "Country",
      dataIndex: "country_name",
      key: "country_id",
    },
    {
      title: "State",
      dataIndex: "state_name",
      key: "state_id"
    },
    {
      title: "City",
      dataIndex: "city_name",
      key: "city_id",

    },
    {
      title: "Addressee",
      dataIndex: "addressee",
      key: "addressee",

    },
    {
      title: "Address 1",
      dataIndex: "address_1",
      key: "address_1",

    },
    {
      title: "Address 2",
      dataIndex: "address_2",
      key: "address_2",

    },
    {
      title: "Address 3",
      dataIndex: "address_3",
      key: "address_3",

    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Zip Code",
      dataIndex: "zip_code",
      key: "zip_code",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space>
          <Button
            size="small"
            icon={<EditOutlined />}
            onClick={() => hanldeSubItems(record)}
            disabled={!(formType === "add" || formType === "edit")} />
          <Popconfirm
            title="Delete item?"
            description="Are you sure you want to delete this item?"
            onConfirm={() => hanldeDeleteItems(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              size="small"
              icon={<DeleteOutlined />}
              disabled={!(formType === "add" || formType === "edit")}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    if (formType === "add") {
      setShippingAddress([])
    }
    else if (vendor_id != "" && formType === "formView") {
      dispatch(getVendorShipping(token, vendor_id)).then((res) => {
        if (res.type === "GET_VENDOR_SHIPPING_SUCCESS") {

          setShippingAddress(res?.payload?.data)
          addressDataShip(res?.payload?.data)

        }

      })
      setShowTable(true);
    }
    else { setShowTable(false); }
  }, [vendor_id]);

  useEffect(() => {
    dispatch(loadCountry(token));
  }, []);

  const hanldeSubItems = (record) => {
    if (formType === "edit") {
      setEventType("edit");
      setShipID(record?.vendor_ship_to_id);
    }
    setVisible(true);
    form.setFieldsValue({
      addressee: record.addressee,
      address_1: record.address_1,
      address_2: record.address_2,
      address_3: record.address_3,
      email: record.email,
      fax: record.fax,
      phone: record.phone,
      zip_code: record.zip_code,
      city: record.country_id,
      state: record.state_id,
      country: record.country_id,
      is_active: record.is_active
    });
    dispatch(loadCountry(token))
    dispatch(loadCity(token, record.country_id));
    dispatch(loadState(token, record.country_id));
  };



  const hanldeDeleteItems = (record) => {
    if (formType === "add") {
      const updatedBillingAddress = shippingAddress.filter((item) => item.key !== record.key);
      setShippingAddress(updatedBillingAddress);
      addressDataShip(updatedBillingAddress);
    } else {
      let deletedItems = [...deletedShipItems];
      let updatedShippingAddress = shippingAddress.filter((item) => item.vendor_ship_to_id !== record.vendor_ship_to_id);
      setShippingAddress(updatedShippingAddress);
      addressDataShip(updatedShippingAddress);
      deletedItems.push(record);
      setDeletedShipItems(deletedItems);

    }


  };

  const onChangeCountry = (value, obj) => {
    setCountry(obj);

    dispatch(loadCity(token, `${value}`));
    dispatch(loadState(token, `${value}`));

    setDisableFields(true);
  };
  const onChangeCity = (value, obj) => {
    setCity(obj);
  };
  const onChangeState = (value, obj) => {
    setState(obj);
  };

  const onSearch = (val) => {

  };

  const handleOk = async (e) => {
    form.setFieldsValue({ [e.target.name]: e.target.value });
    await form.validateFields().then((values) => {

      console.log("values", values);
      console.log("values eventType", eventType);
      if (eventType === "add") {
        let payload = {
          address_1: values.address_1,
          address_2: values.address_2,
          address_3: values.address_3,
          addressee: values.addressee,
          country_id: values.country,
          country_name: countryForm.children,
          state_id: values.state,
          state_name: stateForm.children,
          city_id: values.city,
          city_name: cityForm.children,
          email: values.email,
          phone: values.phone,
          key: `${Date.now()}-${Math.random().toString(36).substring(2, 7)}`,
          fax: values.fax,
          zip_code: values.zip_code,
          is_deleted: 0,
          is_active: values.is_active,
        };
        let data = [...shippingAddress, payload];
        setShippingAddress(data);
        addressDataShip(data);

        console.log("payload", data);
      } else if (eventType === "edit" && shipID !== null) {
        const data = shippingAddress.map((item) =>
          item.vendor_ship_to_id === shipID
            ? {
              ...item,
              address_1: values.address_1,
              address_2: values.address_2,
              address_3: values.address_3,
              addressee: values.addressee,
              country_id: values.country,
              country_name: countryForm?.children || item.country_name,
              state_id: values.state,
              state_name: stateForm?.children || item.state_name,
              city_id: values.city,
              city_name: cityForm?.children || item.city_name,
              email: values.email,
              phone: values.phone,
              fax: values.fax,
              zip_code: values.zip_code,
              is_active: values.is_active,
              is_deleted: 0,
            }
            : item
        );

        setShippingAddress(data);
        addressDataShip(data);

      }

      setVisible(false);

      form.setFieldsValue({
        addressee: null,
        address_1: null,
        address_2: null,
        address_3: null,
        email: null,
        fax: null,
        phone: null,
        zip_code: null,
        city: null,
        state: null,
        country: null,
        active: null
      })


    });
  };

  const handleCancel = () => {
    setVisible(false);
    form.setFieldsValue({
      addressee: null,
      address_1: null,
      address_2: null,
      address_3: null,
      email: null,
      fax: null,
      phone: null,
      zip_code: null,
      city: null,
      state: null,
      country: null,
    });
  };

  const getModalData = () => {
    dispatch(loadCountry(token));
    setEventType("add")
    setVisible(true)
  }

  return (
    <>
      <div>
        <Modal

          className="modal-40"
          visible={visible}
          title="Shipping Form"
          okText="Submit"
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <Form
            form={form}
            layout="vertical"
            name="form_in_modal"
            initialValues={{
              modifier: "public",
            }}
          >

            <div className="container-fluid p-0 modal-form-main">
              <Brow>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="addressee" label="Addressee">
                    <Input size="small" className="b-radius-10" />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="address_1" label="Address">
                    <Input size="small" className="b-radius-10" />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="address_2" label="Address">
                    <Input size="small" className="b-radius-10" />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="address_3" label="Address">
                    <Input size="small" className="b-radius-10" />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="country" label="Country">
                    <Select
                      size="small"
                      showSearch

                      optionFilterProp="children"
                      value={countryForm}
                      onChange={onChangeCountry}
                      onSearch={onSearch}
                      filterOption={(input, options) =>
                        options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                      {country?.payload?.data.map((country) => (
                        <Option value={country.country_id}>
                          {country.country_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="city" label="City">
                    <Select
                      size="small"
                      showSearch

                      optionFilterProp="children"
                      value={cityForm}
                      onChange={onChangeCity}
                      onSearch={onSearch}

                    >
                      {City?.payload?.data.map((city) => (
                        <Option value={city.city_id}>{city.city_name}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="state" label="State">
                    <Select
                      size="small"
                      showSearch

                      optionFilterProp="children"
                      value={stateForm}
                      onChange={onChangeState}
                      onSearch={onSearch}
                      filterOption={(input, options) => options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                      {State?.payload?.data.map((state) => (
                        <Option value={state.state_id}>{state.state_name}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="email" label="Email"
                    rules={[{ type: 'email', message: 'The input is not valid E-mail!' }]}>
                    <Input
                      size="small"
                      className="b-radius-10" />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="fax" label="Fax">
                    <Input size="small" className="b-radius-10" />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="phone" label="Phone"
                    rules={[{ pattern: new RegExp(/^[0-9\b]+$/), message: "Must be a Number" }]}>
                    <Input size="small" className="b-radius-10" />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item name="zip_code" label="Zip" rules={[{ pattern: new RegExp(/^[0-9\b]+$/), message: "Must be a Number" }]}>
                    <Input size="small" className="b-radius-10" />
                  </Form.Item>
                </Bcol>
                <Bcol lg={6} xl={6} xxl={6}>
                  <Form.Item
                    label="Active"
                    name="is_active"
                  >
                    <Checkbox size="small" className="styleInput" checked={check} defaultChecked />
                  </Form.Item>
                </Bcol>
              </Brow>
            </div>


          </Form>
        </Modal>
      </div>

      {/* <div className="productTable"> */}
      <Button
        disabled={!(formType === "add" || formType === "edit")}
        className="iconBtn crudBTN float-right mbpx-5"
        shape="circle"
        icon={<PlusOutlined />}
        onClick={() => getModalData()}
      />
      <Tables
        type="shipping"
        scroll={600}
        perPage={5}
        scrollX={"45rem"}
        source={shippingAddress}
        col={shippingColumns}
        load={Shipping.loading}
        paginate
      />
      {/* </div> */}

    </>
  );
}
